import React, { useEffect, useRef, useState } from "react";
import chatLogo from "assets/images/birdyLogo.png";
import senticon from "assets/images/sent-icon.png";
import userIcon from "assets/images/user-profile-icon.png";
import { TfiClose } from "react-icons/tfi";

const Birdy = () => {
  const [showChat, setShowChat] = useState(false);
  const [showOuterMessage, setShowOutermessage] = useState(false);
  const [greetMessage, setGreetMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [showBird, setSHowBird] = useState(false);

  const chatContainerRef = useRef(null);

  const toggleSHowOuterMessage = () => setShowOutermessage((pre) => !pre);
  const toggleShowChat = () => {
    setShowChat((pre) => !pre);
    setShowOutermessage(false);
  };

  const sendMessage = async () => {
    if (!input) return;
    setInput("");

    const userMessage = { sender: "user", text: input };
    setMessages((prev) => [...prev, userMessage]);

    try {
      const response = await fetch(
        "https://birdy.teachwings.com/webhooks/rest/webhook",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            sender: "user_id",
            message: input,
          }),
        }
      );

      if (response.ok) {
        const data = await response.json();
        data.forEach((botResponse) => {
          if (botResponse.text) {
            const botMessage = { sender: "bot", text: botResponse.text };
            setMessages((prev) => [...prev, botMessage]);
          }
        });
      } else {
        console.error(
          "Failed to send message. Response status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  const getGretting = () => {
    const today = new Date();
    const curHr = today.getHours();
    let message = "";
    if (curHr < 12) {
      message = `Good morning ${"!   "} May I help you`;
    } else if (curHr < 18) {
      message = `Good afternoon ${"!   "}  May I help you`;
    } else {
      message = `Good evening ${"!   "}  May I help you`;
    }
    setGreetMessage(message);
    setMessages([
      {
        sender: "bot",
        text: message,
      },
    ]);
  };

  useEffect(() => {
    const timer2 = setTimeout(() => {
      setSHowBird(true);
    }, 1000);

    const timer = setTimeout(() => {
      setShowOutermessage(true);
    }, 2000);

    let timer3;
    if (showOuterMessage) {
      timer3 = setTimeout(() => {
        toggleSHowOuterMessage();
      }, 10000);
    } else {
      clearTimeout(timer3);
    }

    return () => {
      clearTimeout(timer2);
      clearTimeout(timer);
      clearTimeout(timer3);
    };
  }, []);

  useEffect(() => {
    getGretting();
  }, []);

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTo({
        top: chatContainerRef.current.scrollHeight,
        behavior: "smooth", // Enables smooth scrolling
      });
    }
  }, [messages]);

  return (
    <>
      <div
        className={`fixed bottom-1 sm:bottom-5 right-1 sm:right-8  ${
          showBird ? "opacity-100 scale-100" : "opacity-0 scale-0"
        } transition-all duration-500 ease-in-out z-[2147483647]`}
      >
        <div
          onClick={() => toggleShowChat()}
          className="w-[50px] h-[50px] sm:w-[70px] sm:h-[70px] z-50 cursor-pointer"
        >
          <img
            src={chatLogo}
            alt="bird-icon"
            className="w-full h-full object-contain"
          />
        </div>
        {showOuterMessage && (
          <div className="absolute bottom-[100%] right-[95%]">
            <div className="flex border bg-white p-2 shadow-2xl rounded-md border-1 max-w-56 min-w-40">
              <div className="flex-1 break-words">
                <p className="text-sm">{greetMessage}</p>
              </div>
              <div
                onClick={toggleSHowOuterMessage}
                className="cursor-pointer flex justify-center items-center ml-2 p-[10px] border-2 w-2 h-2 rounded-full border-gray-500 text-gray-500 bg-gray-200"
              >
                X
              </div>
            </div>
          </div>
        )}
      </div>

      <div
        className={`fixed bottom-0 right-0 sm:bottom-[75px] sm:right-16 z-[${
          showChat ? "2147483647" : "1000000"
        }] sm:z-[1000000]`}
      >
        <div
          className={`transition-all duration-300 ease-in-out  bg-white rounded-lg overflow-hidden  shadow-2xl 
                ${
                  showChat
                    ? "w-[100vw] h-[100vh] sm:w-[360px] sm:h-[400px] opacity-[1]"
                    : "w-[0px] h-[0px] opacity-0"
                }`}
        >
          <div className="min-h-[45px] bg-[#1778BE] flex items-center justify-between px-5 gap-2">
            <div className="flex items-center gap-2">
              <div className="w-[30px] h-[30px]">
                <img src={chatLogo} className="w-full h-full object-contain" />
              </div>
              <h4 className="text-white font-medium text-[16px]">Birdy</h4>
            </div>
            <TfiClose
              className="cursor-pointer w-[25px] h-[25px] text-white"
              onClick={() => toggleShowChat()}
            />
          </div>

          <div className={"pt-0"} style={{ height: "calc(100% - 45px)" }}>
            <div
              ref={chatContainerRef}
              style={{ height: "calc(100% - 75px)" }}
              className={`flex flex-col gap-2 p-4 overflow-auto`}
            >
              {messages.map((msg, idx) => (
                <div
                  key={idx}
                  className={`max-w-[80%] ${
                    msg.sender === "bot" ? "self-start" : "self-end"
                  }`}
                >
                  <div className="flex gap-1">
                    {msg.sender === "bot" && (
                      <img
                        src={chatLogo}
                        className="w-4 h-4 object-contain self-end drop-shadow-xl"
                      />
                    )}
                    <div className="flex-1">
                      <p
                        className="p-1 text-[13px]"
                        style={{
                          background: msg.sender === "bot" ? "#eee" : "#1A4C7C",
                          color: msg.sender === "bot" ? "#000" : "#fff",
                          borderRadius: "5px",
                        }}
                      >
                        {msg.text}
                      </p>
                    </div>
                    {msg.sender !== "bot" && (
                      <img
                        src={userIcon}
                        className="cursor-pointer w-3 h-3  rounded-full object-contain self-end drop-shadow-xl"
                      />
                    )}
                  </div>
                </div>
              ))}
            </div>

            <div className="sticky bottom-0 left-0 p-4 bg-white">
              <div className="border flex items-center rounded-lg overflow-hidden bg-gray-200">
                <input
                  className="w-full p-2 outline-none bg-gray-100"
                  value={input}
                  onChange={(e) => {
                    setInput(e.target.value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      sendMessage();
                    }
                  }}
                />
                <div className="pr-4  cursor-pointer" onClick={sendMessage}>
                  <img src={senticon} className="w-6 h-auto rotate-45" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Birdy;
